const scheduleData = [
  {
    date: "1/11/22",
    title: "Introduction, Overview",
    readings: [],
    slides: "slides_Jan11.pdf",
    dSlides: null,
    activity: null,
    commentary: null,
    experienceLog: null,
    groupProject: [],
    readings: []
  },
  {
    date: "1/13/22",
    title: "Key concepts in cybersecurity",
    commentary: true,
    slides: "slides_Jan13.pdf",
    readings: [
      {
        text: "A Non-Technical Introduction to Cybersecurity",
        href: "https://medium.com/@scyrus89/a-non-technical-introduction-to-cybersecurity-f4d42b9a1ff2"
      },
      {
        text: "Unfalsifiability of Security Claims",
        href: "https://www.pnas.org/content/pnas/113/23/6415.full.pdf"
      }
    ],
    assignment: [],
    notes: []
  },
  {
    date: "1/18/22",
    title: "Key concepts in privacy",
    slides: "slides_Jan18.pdf",
    commentary: true,
    readings: [
      {
        text: "\"I've Got Nothing to Hide\" and Other Misunderstandings of Privacy",
        href: "https://papers.ssrn.com/sol3/papers.cfm?abstract_id=998565"
      },
      {
        text: "End-User Privacy in Human-Computer Interaction, Ch. 2",
        href: "http://www.cs.cmu.edu/~jasonh/publications/fnt-end-user-privacy-in-human-computer-interaction-final.pdf"
      }
    ],
    assignment: [],
    groupProject: [
      {
        text: "Individual ideation",
        href: "/individual-ideation"
      }
    ]
  },
  {
    date: "1/20/22",
    title: "Key concepts in usability & design",
    slides: "slides_Jan20.pdf",
    commentary: true,
    readings: [
      {
        text: "How to design",
        href: "https://faculty.washington.edu/ajko/books/design-methods/design"
      },
      {
        text: "The Psychopathology of Everyday Things",
        href: "http://pages.ucsd.edu/~mboyle/COGS1/readings/Norman-COGS1-The%20Psychopathology-of-Everyday-Things.pdf"
      }
    ],
    experienceLog: "",
    assignment: [],
    notes: []
  },
  {
    date: "1/25/22",
    title: "Foundations of human-centered security",
    slides: "slides_Jan25.pdf",
    commentary: true,
    virtual: true,
    readings: [
      {
        text: "Users are not the enemy",
        href: "http://discovery.ucl.ac.uk/20247/2/CACM%20FINAL.pdf"
      },
      {
        text: "Crypto for the People",
        href: "https://www.youtube.com/watch?v=Ygq9ci0GFhA"
      }
    ],
  },
  {
    date: "1/27/22",
    title: "Research & science writing in usable privacy & security",
    slides: "slides_Jan27.pdf",
    commentary: true,
    virtual: true,
    readings: [
      {
        text: "Research Contributions in Human-Computer Interaction",
        href: "https://faculty.washington.edu/wobbrock/pubs/interactions-16.pdf"
      },
      {
        text: "Common Pitfalls in Writing about Security and Privacy Human Subjects Experiments, and How to Avoid Them",
        href: "https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/commonpitfalls.pdf"
      },
      {
        text: "A summary of survey methodology best practices for security and privacy researchers (optional)",
        href: "https://drum.lib.umd.edu/bitstream/handle/1903/19227/CS-TR-5055.pdf"
      },
      {
        text: "Making experiments dependable (optional)",
        href: "http://www.cs.cmu.edu/~maxion/pubs/Maxion12.pdf"
      },
    ],
    groupProject: [
      {
        text: "Group ideation",
        href: "/group-ideation"
      }
    ],
  },
  {
    date: "2/1/22",
    title: "Encryption",
    slides: "slides_Feb1.pdf",
    // dSlides: "Encryption.pdf",
    commentary: true,
    readings: [
      {
        text: "Why Johnny Can't Encrypt? A Usability Evaluation of PGP 5.0",
        href: "http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.40.9279&rep=rep1&type=pdf"
      },
      {
        text: "Secrecy, Flagging, and Paranoia: Adoption Criteria in Encrypted E-Mail",
        href: "https://dl.acm.org/doi/pdf/10.1145/1124772.1124862?casa_token=gTpXsxE6I1gAAAAA:KzGor5R6TvcrXs5ixmK-oWDHdmVKqMITxNpqSHBUk_JpxHQLKeqmIGkhKwiScBaXsSB9wI8aQ4DQFg"
      }
    ],
    experienceLog: "",
    assignment: [],
    notes: []
  },
  {
    date: "2/3/22",
    title: "Authentication & access control",
    slides: "slides_Feb3.pdf",
    // dSlides: "Passwords_Authentication.pptx",
    commentary: true,
    readings: [
      {
        text: "The quest to replace passwords: A framework for comparative evlaution of web authentication schemes",
        href: "https://ieeexplore.ieee.org/stamp/stamp.jsp?arnumber=6234436"
      },
      {
        text: "Access control for home data sharing: Attitudes, needs and practices",
        href: "https://www.archive.ece.cmu.edu/~lbauer/papers/2010/chi2010-home-access-control.pdf"
      }
    ],
    assignment: [],
    notes: [],
    groupProject: [
      {
        text: "Project proposal",
        href: "proposals"
      }
    ],
  },
  {
    date: "2/8/22",
    title: "Phishing & social engineering",
    slides: "slides_Feb8.pdf",
    // dSlides: "Social_Engineering.pptx",
    commentary: true,
    readings: [
      {
        text: "Why Phishing Works",
        href: "https://dl.acm.org/doi/pdf/10.1145/1124772.1124861?casa_token=SffNCAP6Ze8AAAAA:XIG9ui4b1F_6Lvj4QitTrCGuMhRI9peGAaar3UYYxrJaceu-G2DJYtzCjIDW6IjE5U9Usb_42HGg2g"
      },
      {
        text: "Social phishing",
        href: "http://markus-jakobsson.com/papers/jakobsson-commacm07.pdf"
      }
    ],
    assignment: [],
    groupProject: [
    ]
  },
  {
    date: "2/10/22",
    title: "Notifications & updates",
    slides: "slides_Feb10.pdf",
    // dSlides: "https://docs.google.com/presentation/d/1GFzXzPOWtQr26pRrwP43RSTfVhU1UbrGmVmTx2yttsg",
    commentary: true,
    readings: [
      {
        text: "A design space for effective privacy notices",
        href: "https://www.usenix.org/system/files/conference/soups2015/soups15-paper-schaub.pdf"
      },
      {
        text: "Betrayed By Updates: How Negative Experiences Affect Future Security",
        href: "https://www.research.ed.ac.uk/portal/files/23097743/chi2014.pdf"
      }
    ]
  },
  {
    date: "2/15/22",
    title: "Security warnings",
    slides: "slides_Feb15.pdf",
    commentary: true,
    virtual: true,
    readings: [
      {
        text: "Alice in Warningland: A Large-Scale Field Study of Browser Security Warning Effectiveness",
        href: "https://www.usenix.org/system/files/conference/usenixsecurity13/sec13-paper_akhawe.pdf"
      },
      {
        text: "Spidey Sense: Designing Wrist-Mounted Affective Haptics for Communicating Cybersecurity Warnings",
        href: "https://sauvikdas.com/papers/29/serve"
      }
    ],
    experienceLog: "",
    groupProject: [
      {
        text: "Proposal revision",
        href: "proposals#revision"
      }
    ]
  },
  {
    date: "2/17/22",
    title: "Privacy & security in human behavior",
    slides: "slides_Feb17.pdf",
    virtual: true,
    dSlides: "https://docs.google.com/presentation/d/1ICPMJhkXX7qW27SdQ_f73u_SVGRFycfahqdtNYF7YYo/edit?usp=sharing",
    readings: [
      {
        text: "Privacy and human behavior in the age of information",
        href: "http://science.sciencemag.org/content/sci/347/6221/509.full.pdf"
      },
      {
        text: "\"...no one can hack my mind\": Comparing Expert and Non-Expert Security Practices",
        href: "https://www.usenix.org/sites/default/files/soups15_full_proceedings.pdf#page=349"
      }
    ],
    commentary: true,
    groupProject: [
    ]
  },
  {
    date: "2/22/22",
    title: "Nudges & behavioral economics",
    slides: "slides_Feb22.pdf",
    // dSlides: "https://docs.google.com/presentation/d/1ICPMJhkXX7qW27SdQ_f73u_SVGRFycfahqdtNYF7YYo/edit?usp=sharing",
    readings: [
      {
        text: "Nudges for Privacy and Security: Understanding and Assisting Users’ Choices Online",
        href: "https://dl.acm.org/doi/pdf/10.1145/3054926"
      },
      {
        text: "So Long, And No Thanks for the Externalities: The Rational Rejection of Security Advice by Users",
        href: "https://dl.acm.org/doi/pdf/10.1145/1719030.1719050?casa_token=beEYtmFzf3QAAAAA:yzblbXTnX6z5nZtZ8K0-1FwkkWTcwoOE-5jXk0aycs6onG1CFa4jXcoi0njLmn1ZaxrBThKFRJScFA"
      }
    ],
    commentary: true
  },
  {
    date: "2/24/22",
    title: "Mental models (guest lecture: Youngwook Do)",
    slides: "slides_Feb24.pdf",
    // dSlides: "Krishna_MM.pptx",
    commentary: true,
    readings: [
      {
        text: "Folk Models of Home Computer Security",
        href: "https://cups.cs.cmu.edu/soups/2010/proceedings/a11_Walsh.pdf"
      },
      {
        text: "\"My Data Just Goes Everywhere:\" User Mental Models of the Internet and Implications for Privacy and Security",
        href: "https://www.usenix.org/system/files/conference/soups2015/soups15-paper-kang.pdf"
      }
    ],
  },
  {
    date: "3/1/22",
    commentary: true,
    title: "Social cybersecurity",
    slides: "slides_Mar1.pdf",
    // dSlides: "Social_Cybersecurity_0307.pdf",
    readings: [
      {
        text: "SoK: Social Cybersecurity",
        href: "https://sauvikdas.com/papers/36/serve"
      },
      {
        text: "The Role of Social Influence In Security Feature Adoption",
        href: "https://sauvikdas.com/papers/10/serve"
      },
    ],
    groupProject: [
      {
        text: "Progress report 1",
        href: "/progress-reports"
      }
    ]
  },
  {
    date: "3/3/22",
    commentary: true,
    title: "Profiling and targeted advertising",
    slides: "slides_Mar3.pdf",
    // dSlides: "Social_Cybersecurity_0307.pdf",
    readings: [
      {
        text: "Folk Models of Online Behavioral Advertising",
        href: "https://dl.acm.org/doi/pdf/10.1145/2998181.2998316"
      },
      {
        text: "Smart, Useful, Scary, Creepy: Perceptions of Online Behavioral Advertising",
        href: "https://dl.acm.org/doi/pdf/10.1145/2335356.2335362?casa_token=16BDYgMhheAAAAAA:vhPP3auXRrDuBAfnqGj82vp_92vG-D-Fmlfr8V8fGFHQguI_sRiGstdNX4jl6cx-yu5cu-bEvj2b"
      },
    ],
  },
  {
    date: "3/8/22",
    title: "Developer perspectives",
    commentary: true,
    slides: "slides_Mar8.pdf",
    // dSlides: "https://docs.google.com/presentation/d/1Som78BTdnesUrrGqLcTpCe4-uuOFh46ZRlPpSIAUBdI/edit?usp=sharing",
    readings: [
      {
        text: "You Get Where You’re Looking For: The Impact of Information Sources on Code Security",
        href: "http://users.umiacs.umd.edu/~mmazurek/papers/sp2016-impact-information-resources.pdf"
      },
      {
        text: "Social Influences on Secure Development Tool Adoption: Why Security Tools Spread",
        href: "https://people.engr.ncsu.edu/ermurph3/papers/cscw13.pdf"
      }
    ],
    experienceLog: ""
  },
  {
    date: "3/10/22",
    title: "Equity & Inclusivity",
    slides: "slides_Mar10.pdf",
    // dSlides: "Inclusive_SnP.pdf",
    commentary: true,
    readings: [
      {
        text: "Where is the Digital Divide? A Survey of Security, Privacy, and Socioeconomics",
        href: "https://drum.lib.umd.edu/bitstream/handle/1903/18867/CS-TR-5050-r1.pdf?sequence=3"
      },
      {
        text: "Keeping a Low Profile? Technology, Risk and Privacy among Undocumented Immigrants",
        href: "https://amcdon.com/papers/lowprofile-chi18.pdf"
      }
    ]
  },
  {
    date: "3/15/22",
    title: "Accessibility",
    slides: "slides_Mar15.pdf",
    // dSlides: "Inclusive_SnP.pdf",
    commentary: true,
    virtual: true,
    readings: [
      {
        text: "Blind and Human: Exploring More Usable Audio CAPTCHA Designs",
        href: "https://sauvikdas.com/papers/25/serve"
      },
      {
        text: "WebAlly: Making Visual Task-based CAPTCHAs Transferable for People with Visual Impairments ",
        href: "https://sauvikdas.com/papers/30/serve"
      }
    ]
  },
  {
    date: "3/17/22",
    title: "Security, privacy & activism",
    slides: "slides_Mar17.pdf",
    // dSlides: "Inclusive_SnP.pdf",
    commentary: true,
    virtual: true,
    readings: [
      {
        text: "Defensive Technology Use by Political Activists During the Sudanese Revolutio",
        href: "https://homes.cs.washington.edu/~yoshi/papers/daffalla-simko-activism.pdf"
      },
      {
        text: "Understanding the Security and Privacy Advice Given to Black Lives Matter Protesters",
        href: "https://dl.acm.org/doi/pdf/10.1145/3411764.3445061"
      }
    ],
  },
  {
    date: "3/22/22",
    title: "Spring break (no class)",
    readings: [
    ],
    assignment: [],
    notes: []
  },
  {
    date: "3/24/22",
    title: "Spring break (no class)",
    readings: [
    ],
    assignment: [],
    notes: []
  },
  {
    date: "3/29/22",
    title: "Obfuscation",
    slides: "slides_Mar29.pdf",
    commentary: true,
    readings: [
      {
        text: "Surveillance Countermeasures: Expressive Privacy Via Obfuscation ",
        href: "https://openresearch.lsbu.ac.uk/download/85763506b38d5feddd169dc967db97b14160704a2cb227c421d05de278c9a03a/4129396/datafiedresearch8402-971-PB.pdf#page=88"
      },
      {
        text: "Image DePO: Towards Gradual Decentralization of Online Social Networks using Decentralized Privacy Overlays",
        href: "https://sauvikdas.com/papers/37/serve"
      }
    ],
    experienceLog: "Review log 3"
  },
  {
    date: "3/31/22",
    title: "Networked privacy",
    slides: "slides_Mar31.pdf",
    // dSlides: "SocialMedia.pptx",
    commentary: true,
    readings: [
      {
        text: "Networked privacy: How teenagers negotiate context in social media",
        href: "https://journals.sagepub.com/doi/pdf/10.1177/1461444814543995"
      },
      {
        text: "Exploring the Utility Versus Intrusiveness of Dynamic Audience Selection on Facebook",
        href: "https://sauvikdas.com/papers/31/serve"
      }
    ],
    groupProject: [
      {
        text: "Progress report 2",
        href: "/progress-reports#2"
      }
    ]
  },
  {
    date: "4/5/22",
    title: "IoT and Physical Privacy",
    slides: "slides_Apr5.pdf",
    commentary: true,
    readings: [
      {
        text: "End User Security and Privacy Concerns with Smart Homes",
        href: "https://www.usenix.org/system/files/conference/soups2017/soups2017-zeng.pdf"
      },
      {
        text: "Smart Webcam Cover: Exploring the Design of an Intelligent Webcam Cover to Improve Usability and Trust",
        href: "https://sauvikdas.com/papers/35/serve"
      }
    ],
    groupProject: []
  },
  {
    date: "4/7/22",
    title: "Privacy by and through Design",
    slides: "slides_Apr7.pdf",
    commentary: true,
    readings: [
      {
        text: "Privacy by Design - Principles of Privacy-Aware Ubiquitous Systems",
        href: "https://www.cs.cmu.edu/~jasonh/courses/ubicomp-sp2007/papers/05-privacy-principles.pdf"
      },
      {
        text: "Bringing Design to the Privacy Table: Broadening 'Design' in 'Privacy by Design' Through the Lens of HCI",
        href: "https://dl.acm.org/doi/pdf/10.1145/3290605.3300492"
      }
    ],
    groupProject: []
  },
  {
    date: "4/12/22",
    title: "AI & Surveillance (guest lecture: Jacob Logas)",
    slides: "slides_Apr12.pdf",
    virtual: false,
    // dSlides: "IoT.pptx",
    commentary: true,
    readings: [
      {
        text: "Subversive AI:  Resisting automated algorithmic surveillance with human-centered adversarial machine learning",
        href: "https://sauvikdas.com/papers/27/serve"
      },
      {
        text: "Fawkes: Protecting Privacy against Unauthorized Deep Learning Models",
        href: "https://www.usenix.org/system/files/sec20-shan.pdf"
      }
    ],
    groupProject: []
  },
  {
    date: "4/14/22",
    title: "Privacy for the People (guest lecture: Yuxi Wu)",
    slides: "slides_Apr14.pdf",
    virtual: false,
    // dSlides: "AI_Automation.pptx",
    commentary: true,
    readings: [
      {
        text: "Data Leverage: A Framework for Empowering the Public in its Relationship with Technology Companies",
        href: "https://dl.acm.org/doi/pdf/10.1145/3442188.3445885?casa_token=pcATT-9SVEwAAAAA:XOqiRZXk-dq1FYzHmpcBH8UgLGUhQ6m9Q7dgHLCxeLnd6oHkG1KA312cpdLeXBQV9ZvhFRG4c1SDtg"
      },
      {
        text: "“A Reasonable Thing to Ask For”: Towards a Unified Voice in Privacy Collective Action",
        href: "https://sauvikdas.com/papers/39/serve"
      }
    ],
    groupProject: []
  },
  {
    date: "4/19/22",
    title: "Final presentations",
    commentary: false,
    readings: [],
    groupProject: [
      {
        text: "Final presentation",
        href: "/final-presentation"
      }
    ]
  },
  {
    date: "4/21/22",
    title: "Final presentations",
    commentary: false,
    readings: [],
    groupProject: [
    ]
  },
  {
    date: "4/26/22",
    title: "Recap & open problems in usable privacy & security",
    slides: "slides_Apr26.pdf",
    commentary: false,
    readings: [
      {
        text: "On Security Singularities",
        href: "https://dl.acm.org/doi/pdf/10.1145/3285002.3285008?casa_token=qScAEtwOpM4AAAAA:1T5pP9jLbLKTBuMbU-jhz9hDdb2yqwJCLabHu0ScS9RYQVgV5OwSIEOEvNTh35Cde0r3tKinj3Dt5g"
      },
      {
        text: "This World of Ours",
        href: "https://www.usenix.org/system/files/1401_08-12_mickens.pdf"
      }
    ],
    groupProject: [
      {
        text: "Final paper",
        href: "/final-paper"
      }
    ]
  },
];

export default scheduleData;


// WEBPACK FOOTER //
// ./src/data/schedule.js